// segmentSound.js
var SegmentSound = pc.createScript('segmentSound');

SegmentSound.attributes.add('syncEnt', {type: 'entity', title: 'syncEnt'});
SegmentSound.attributes.add('allSounds', {type: 'asset', array: true});

// initialize code called once per entity
SegmentSound.prototype.initialize = function() {
    this.loopCnt = 1;
    this.rnd = 1;
    this.app.on('reTrigger', this.reTrigger, this);
    this.app.on('stopSounds', this.stopSounds,this);
    
};

SegmentSound.prototype.reTrigger = function(){
    
    if(this.loopCnt == 4){
        this.rnd = Math.floor(Math.random() * this.allSounds.length);
        this.loopCnt = 1;
    } else if(this.loopCnt < 4){
        this.loopCnt += 1;
    }
    
    this.entity.sound.removeSlot('beep');
    this.entity.sound.addSlot('beep', {
        loop: true,
        asset: this.allSounds[this.rnd]
    });
    console.log('loopcount: ' + this.loopCnt);
    this.entity.sound.play('beep');
};

SegmentSound.prototype.stopSounds = function() {
    this.entity.sound.stop('beep');
};



// update code called every frame


// swap method called for script hot-reloading
// inherit your script state here
// SegmentSound.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// http://developer.playcanvas.com/en/user-manual/scripting/

